import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: string): Date | null {
    if (!value || typeof value !== 'string') {
      return null;
    }

    // Limpiar espacios en blanco
    const cleanValue = value.trim();

    // Intentar parsear formato dd/mm/yyyy
    // SIEMPRE interpretar como: primer número = día, segundo número = mes
    const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const match = cleanValue.match(dateRegex);

    if (match) {
      // SIEMPRE interpretar como día/mes/año (formato europeo)
      const day = parseInt(match[1], 10);   // Primer grupo = día
      const month = parseInt(match[2], 10) - 1; // Segundo grupo = mes (0-indexado)
      const year = parseInt(match[3], 10);

      // Validar rangos básicos
      if (day >= 1 && day <= 31 && month >= 0 && month <= 11 && year >= 1900 && year <= 9999) {
        const date = new Date(year, month, day);
        
        // Verificar que la fecha creada sea válida y coincida con lo ingresado
        if (
          date.getDate() === day &&
          date.getMonth() === month &&
          date.getFullYear() === year
        ) {
          return date;
        }
      }
    }

    // Si tiene formato con slash pero no coincide, no usar parse nativo
    // porque podría interpretar incorrectamente como MM/DD/YYYY
    if (cleanValue.includes('/')) {
      return null;
    }

    // Solo usar parse nativo si no tiene formato de fecha con slash
    return super.parse(value);
  }

  override format(date: Date, displayFormat: string): string {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate();
    const month = date.getMonth() + 1; // Los meses en JavaScript son 0-indexados
    const year = date.getFullYear();

    // Formatear como dd/mm/yyyy (ignorar displayFormat y siempre usar este formato)
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  }

  override getDateNames(): string[] {
    return super.getDateNames();
  }
}



























